import type { QuestionModule } from "../contracts";
import { rowSpecifyFields } from "../specify/rowFields";
import {
  gridNumericCore,
  type GridNumericDefinition,
  type GridNumericDraft,
  type GridNumericEvent,
  type GridNumericRaw,
  type GridNumericResponse,
} from "./core";
import { GridNumericView } from "./views";

export const gridNumericModule: QuestionModule<
  GridNumericRaw,
  GridNumericDefinition,
  GridNumericDraft,
  GridNumericEvent,
  GridNumericResponse
> = {
  type: "grid_numeric",
  galleryFeatures: [
    "visual-groups",
    "row-custom-text",
    "baseline",
    "rows",
    "columns",
    "autosum-rows",
    "autosum-columns",
    "images",
    "row-images",
    "restored",
    "blank-zero",
    "numeric-list",
  ],
  core: gridNumericCore,
  prompt: (definition) => ({
    content: definition.prompt,
    image: definition.image,
    altText: definition.altText,
    error: definition.error,
  }),
  views: {
    default: {
      id: "default",
      label: "Numbers",
      component: GridNumericView,
      space: "expanded",
      arrangements: ["compact", "wide"],
      requiredControls: ["primary-action"],
    },
  },
  defaultDisplay: { view: "default" },
  controls: (definition, draft, _display, copy) => ({
    specify: [
      ...rowSpecifyFields(
        definition.rows,
        draft.specifiedRows ?? {},
        (rowId, value): GridNumericEvent => ({
          type: "set-row-label",
          rowId,
          value,
        }),
      ),
    ],
    primaryAction: {
      purpose: "submit",
      label: copy.actions.send,
      action: { type: "submit" },
    },
  }),
};
